function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = React.createElement("path", {
  stroke: "#28348A",
  d: "M16.98 33L1 17.01 17 1",
  fill: "none"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 18 34",
    width: "1em",
    height: "1em"
  }, props), _ref);
};

export default SvgComponent;


// WEBPACK FOOTER //
// ./src/components/sections/ourVirtualExperts/steps/arrow.svg